import { Component, signal } from '@angular/core';
import { NewsSlideoutService } from '../news-slideout/news-slideout.service';
import { NewsItemComponent } from '../news-item/news-item.component';
import { NewsStateService } from '../news-state.service';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-company-news-list',
  templateUrl: './company-news-list.component.html',
  styleUrls: ['./company-news-list.component.sass'],
  imports: [
    NewsItemComponent,
    AsyncPipe,
    TranslatePipe
  ]
})
export class CompanyNewsListComponent {
  selectedCategoryId: string | null = null;

  items$ = this.newsStateService.items$;
  hasNextPage$ = this.newsStateService.hasNextPage$;
  loading$ = this.newsStateService.loading$;
  error$ = this.newsStateService.error$;

  loadingMore = signal<boolean>(false);

  constructor(private newsStateService: NewsStateService,
              private newsSlideoutService: NewsSlideoutService) { }

  openNewsSlideout(newsId: string): void {
    this.newsSlideoutService.openNewsSlideout(newsId);
  }

  onCategorySelected(categoryId: string | null): void {
    this.loadingMore.set(false);
    this.selectedCategoryId = categoryId;
    this.newsStateService.loadNews(categoryId);
  }

  loadMore(): void {
    this.loadingMore.set(true);
    this.newsStateService.loadMore();
  }

}
